import { Component, Input, HostBinding } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'selected-items',
  templateUrl: 'selected-items.component.html',
  styleUrls: ['selected-items.component.scss'],
})
export class SelectedItemsComponent {
  @Input() size: number|string = 0;
  @Input() itemName: string = 'Item';

  @HostBinding('attr.data-ghost')
  dataGhost: string = 'selected-items';

  get itemsText() {
    return this.size === 1 ? this.itemName : `${this.itemName}s`;
  }
}
